import type { FieldWidth, IFieldDefinition, ILocalizedText, IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import type { EditorTab } from './EditorTab';
import type { KeyToggle } from './KeyToggle';

/** Вкладки редактора в порядку прототипу v4 (TABS). */
export const editorTabs: readonly EditorTab[] = ['assignments', 'related', 'comments', 'files', 'history'];
/** Поля ключового рядка в порядку прототипу v4 (feTop / fpKey). */
export const keyToggles: readonly KeyToggle[] = ['status', 'priority', 'due'];
/** Стандартний порядок вкладок запису (місце вкладки, яку вмикає редактор). */
export const tabOrder: readonly string[] = ['lawdesigner', 'visualization', 'read', 'edit', 'general', 'assignments', 'children', 'related', 'comments', 'files', 'history'];
/** Групи, які запис прототипу завжди показує на весь рядок (mkG span), — незалежно від «Увесь рядок». */
const FORCED_FULL: readonly string[] = ['Details', 'Notes', 'Description', 'Links'];
/** Відмітка «Увесь рядок» групи з примусовим повним рядком: елемент розкладки з ключем назви (запис його не показує). */
export const fullMark = 'title';

/** Модуль бази знань: ключовий рядок — лише статус, опис не буває під заголовком (прототип v4 m.key === 'kb'). */
export const isKb = (rt: Pick<IRecordTypeDefinition, 'key'>): boolean => rt.key === 'kb';
/** Англійська назва групи (за нею прототип вирішує повний рядок і подвоєння ширин «Подробиць»). */
export const titleEn = (title: ILocalizedText): string => title.en ?? '';
export const isForcedFull = (title: ILocalizedText): boolean => FORCED_FULL.includes(titleEn(title));
/** «Подробиці» прототипу подвоюють ширину поля (S → M, M → L). */
export const doubled = (width: FieldWidth): FieldWidth => (width === 'S' ? 'M' : 'L');
/** Поля типу, які бачить редактор (без полів лише для даних). */
export const visibleFields = (rt: IRecordTypeDefinition): IFieldDefinition[] => rt.fields.filter((f) => !f.hidden);
/** Ключ поля тегів типу (прототип: будь-яке поле типу tags). */
export const tagsKeyOf = (fields: readonly IFieldDefinition[]): string | undefined => fields.find((f) => f.type === 'tags')?.key;
/** Чи патч несе форму, збережену редактором (ключовий рядок, поля під назвою чи вкладки в forms.full). */
export function editorWritten(patch: IRecordTypeOverride | undefined): boolean {
  const full = patch?.forms?.full;
  return !!full && (full.keyLine != null || full.underTitle != null || full.tabs != null);
}
